import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
const FOREGROUND = '#E3F2FF';
const BACKGROUND = '#81B8E9';

const font = '\'Roboto Condensed Bold\', \'Helvetica Neue Light\', \'HelveticaNeue-Light\', Arial, Helvetica, sans-serif';

export const Component = ({ label, width = 100, height = 100, ...styleOverrides }, context) => {
  const [foreground, background] = context.isInverted ? [BACKGROUND, FOREGROUND] : [FOREGROUND, BACKGROUND];

  const style = {
    fill:          foreground,
    fillOpacity:   0.9,
    fontSize:      '40px',
    fontWeight:    700,
    letterSpacing: '2px',
    stroke:        foreground,
    strokeOpacity: 0.8,
    ...styleOverrides,
  };

  return (
    <svg viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="100%" height="100%" fill={background} fillOpacity="0.9" />
      <text
        fontFamily={font}
        style={style}
        x={width / 2}
        y={height / 2}
        width="100%"
        height="100%"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {label}
      </text>
    </svg>
  );
};

Component.propTypes = {
  label: PropTypes.string.isRequired,
};

Component.contextType = {
  isInverted: PropTypes.bool,
};

export const getDataURI = (label, width, height, other = {}) =>
  'data:image/svg+xml;utf8,' +
  ReactDOMServer.renderToStaticMarkup(<Component label={label} width={width} height={height} {...other} />);

export const getDataURIBase64 = (label, width, height, other = {}) =>
  'data:image/svg+xml;base64,' +
  btoa(ReactDOMServer.renderToStaticMarkup(<Component label={label} width={width} height={height} {...other} />));
